import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from '../locales/en/common.json';
import enLabels from '../locales/en/labels.json';
import usLabels from '../locales/en-US/labels.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon, labels: enLabels },
    'en-US': { labels: usLabels },
  },
  lng: 'en',
  fallbackLng: { 'en-US': ['en'], default: ['en'] },
  defaultNS: 'common',
  ns: ['common', 'labels'],
  interpolation: { escapeValue: false },
});

export default i18n;
